import { IApplicationState } from '../../types/redux';
import { getUser } from './getUser';

export const getUserPhone = (state: IApplicationState) => {
  const user = getUser(state);

  const userPhone = user.phones && user.phones[0];
  const phone = userPhone?.phone;

  return phone ? `+${phone}` : null;
};
